import Model from "./base/model";

class RouteTableFile extends Model{
  resourceName() {
    return "route_tables_files";
  }

  fields() {
    return {
      route_table_id: "",
      user_id: "",
      approval: "",
      path: "",
      name: "",
      route_table: { jsonApi: "hasOne", type: "route_tables"},

    };
  }

}

export default new RouteTableFile();
